import { Injectable } from '@angular/core';
import { map, switchMap, tap } from 'rxjs/operators';
import { BaseRepository } from './base.repository';
import { Observable } from 'rxjs';

@Injectable({
 providedIn: 'root',
})
export class CityRepository extends BaseRepository {
 getAllSectionHome(): Observable<any> {
  const url = this.baseUrl + `citypage`;
  return this.get<any>(url);
 }
 getTheMostLuxuriousHotels(): Observable<any> {
  const url = this.baseUrl + `citypage/GetTheMostLuxuriousAccommodations`;
  return this.get<any>(url);
 }
 getSuggestedHotels(cityId: string): Observable<any> {
  const url = `${this.baseUrl}citypage/GetSuggestedHotels?cityId=${cityId}`;
  return this.http.get<any>(url);
 }
 getCityByIdAndCityName(
  districtType: string,
  districtId: string,
  districtName: string,
  sort: string,
  filters: { key: string; value: any[] }[],
  type: string,
  typeId: string,
  typeTitle: string
 ): Observable<any> {
  let filtersParams = '';
  if (filters.length) {
   filters.forEach((x) => {
    x.value.forEach((val) => (filtersParams += `&${x.key}=${val}`));
   });
  }
  const url = `${this.baseUrl}citypage/district?districtType=${districtType}&districtId=${districtId}&districtName=${districtName}&type=${type}&typeId=${typeId}&typeTitle=${typeTitle}&sort=${sort}${filtersParams}`;

  return this.http.get<any>(url).pipe(
   map((res) => {
    return {
     ...res,
     BreadCrumb: (res.BreadCrumb ?? []).map((b: any) => ({
      url: b.Url,
      name: b.Name,
     })),
    };
   })
  );
 }
}
